import React, { Component, PropTypes } from 'react';
import DownArrow from '../../icons/DownArrow';
import './NavLabel.css';

class NavLabel extends Component {
  constructor() {
    super();
  }

  render() {
    const { selectedText, handleClick } = this.props;
		let selText = '';
		if (selectedText) selText = selectedText;
    return (
      <div>
        {
          !handleClick &&
    			<h3 className="navLabel">
    				{this.props.name}
    				<span className="navLabel__select"> {selText}</span>
          </h3>
        }
        {
          handleClick &&
    			<h3 className="navLabel" onClick={handleClick}>
    				{this.props.name}
    				<span className="navLabel__select"> {selText}</span>
            <div className="navLabel__down">
              <DownArrow
                isActive={this.props.isActive}/>
            </div>
          </h3>
        }
        { this.props.children }
      </div>
    );
  }
}

NavLabel.propTypes = {
	name: PropTypes.string.isRequired,
	selectText: PropTypes.string,
  handleClick: PropTypes.func,
  isActive: PropTypes.bool
};

export default NavLabel;



/** WEBPACK FOOTER **
 ** ./src/components/NavLabel/index.js
 **/